import type { Query } from '@ab-core/graphql/dist';
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { GET_OUTSTANDING_RECEIVABLES } from './gql/getOutstandingReceivables';

type QueryDataType = Pick<Query, 'getOutstandingReceivables'>;
type OutgoingDataType = QueryDataType['getOutstandingReceivables'] | undefined;

const onError = getErrorLoggerFunction('getOutstandingReceivables');

export const useGetOutstandingReceivables = () => {
    const [outgoingData, setOutgoingData] = useState<OutgoingDataType>(undefined);

    const { data, loading, refetch, error } = useQuery<QueryDataType>(GET_OUTSTANDING_RECEIVABLES, {
        onError
    });

    useEffect(() => {
        if (data) {
            setOutgoingData(data.getOutstandingReceivables || []);
        }
    }, [data]);

    return {
        outstandingReceivables: outgoingData,
        error: !!error,
        success: !!data,
        loading,
        refetch
    };
};
